export default __webpack_public_path__ + "static/media/lines.1f3acf9c.png";